import { ColumnConfig, ColumnConfigOptions, CombinedPortfoliosMultiColumnGridExtractorConfig, LodashExtractor, LodashSeriesMapper, TabConfig } from '@ddt-web/data-service';

import { FAMILY_HOLDING_COLUMN_CONFIG } from './family-column.config';

export const FUND_PROSPECTUS = new TabConfig(
	'fund.prospectus',
	null,
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new LodashSeriesMapper(['familyHoldings'], 'familyHoldings.components'),
		null,
		FAMILY_HOLDING_COLUMN_CONFIG,
		ColumnConfig.create({
			id: 'ticker',
			extractor: new LodashExtractor('posInfo.ticker.stringValue', '')
		} as ColumnConfigOptions<LodashExtractor>),
		ColumnConfig.create({
			id: 'weight',
			extractor: new LodashExtractor('weight', 0)
		} as ColumnConfigOptions<LodashExtractor>),
		[
			ColumnConfig.create({
				id: 'cusip',
				extractor: new LodashExtractor('posInfo.cusip.stringValue', '')
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'assetClass',
				extractor: new LodashExtractor('posInfo.acAssetClass.stringValues', '')
			} as ColumnConfigOptions<LodashExtractor>)
		]
	)
);
